module.exports = __webpack_public_path__ + "img/pc-template-category-base.43dc0ea5.jpg";